<template>
  <div>
    <a-card>
      <!-- 查询 -->
      <SearchView
        :renderItem="searchSchema"
        :formLayout="formLayout"
        :initialValues="searchData"
        @fetchSearch="handelSearch"
        :isExpandShowOrNot="false"
      ></SearchView>
    </a-card>
    <a-card style="margin-top:20px;">
      <!-- 结果 -->
      <TableView
        ref="table"
        :columns="columns"
        :pagination="pageData"
        :data="tableData"
        :loading="loading"
        :scroll="scroll"
        @handlePagination="handlePagination"
      >
        <!--所属角色 slot-->
        <template v-slot:roleNames="{ tableRow }">
          <a-tooltip placement="topLeft">
            <template slot="title">
              <span>{{ tableRow.roleNames.join(',') }}</span>
            </template>
            <span>{{ tableRow.roleNames.join(',') }}</span>
          </a-tooltip>
        </template>
        <!--所属部门 slot-->
        <template v-slot:department="{ tableRow }">
          <span>{{ tableRow.department | department }}</span>
        </template>
        <!--状态 slot-->
        <template v-slot:status="{ tableRow }">
          <span>
            <a-tag :color="tableRow.status === 1 ? 'green' : 'volcano'">
              {{ tableRow.status === 1 ? '激活' : '冻结' }}
            </a-tag>
          </span>
        </template>
        <!--操作 slot-->
        <template v-slot:action="{ tableRow }">
          <a-popconfirm
            :title="frozenText"
            @confirm="() => fetchResetPassword(tableRow)"
          >
            <a-icon slot="icon" type="question-circle-o" class="icon-color" />
            <a href="javascript:void(0)" @click="handleReset()">
              密码重置
            </a>
          </a-popconfirm>
        </template>
      </TableView>
    </a-card>
  </div>
</template>

<script>
import { SearchView, TableView } from 'lxfintech-fe'
import mixin from './mixin'
import { getBusinessTableData, resetPassword } from './api'
export default {
  mixins: [mixin],
  components: {
    SearchView,
    TableView,
  },
  data() {
    return {
      loading: '',
      scroll: { x: 1400 }, //滚动设置
      formLayout: 'inline',
      tableData: [],
      pageData: {
        showTotal: total => `总共 ${total} 条`, //展示总条数
      },
      frozenText: '',
    }
  },
  mounted() {
    this._getTableData()
  },
  methods: {
    //获取table数据
    async _getTableData() {
      try {
        this.loading = true
        const { current, pageSize } = this.pageData
        const query = {
          ...this.searchData,
          size: pageSize,
          current,
        }
        delete query.pageSize

        const {
          data: { total, records },
        } = await getBusinessTableData(query)
        this.tableData = records
        this.pageData.total = total
        this.loading = false
      } catch (err) {
        console.log(err)
      }
    },
    //点击查询
    handelSearch(query) {
      this.searchData.name = query.name
      this.searchData.username = query.username
      this.searchData.status = query.status
      this._getTableData()
    },
    //分页
    handlePagination(pagination) {
      ;({
        current: this.pageData.current,
        pageSize: this.pageData.pageSize,
        total: this.pageData.total,
      } = pagination)

      this._getTableData()
    },
    // 密码重置-pop
    handleReset() {
      this.frozenText = '此操作将重置此用户密码, 是否继续?'
    },
    // 密码重置-接口
    async fetchResetPassword(row) {
      try {
        await resetPassword(row.id)
        this._getTableData()
      } catch (err) {
        console.log(err)
      }
    },
  },
}
</script>
<style lang="less" scoped>
#components-a-tooltip-demo-placement .ant-btn {
  width: 70px;
  text-align: center;
  padding: 0;
  margin-right: 8px;
  margin-bottom: 8px;
}
</style>
